import ReactDOM from "react-dom/client"; // Updated import path for React 18
import "./index.css";
import { ApolloProvider, InMemoryCache, ApolloClient } from "@apollo/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Initialize Apollo Client
const client = new ApolloClient({
  uri: "https://ndsuspectrum.com/graphql", // The URL for your WPGraphQL endpoint
  cache: new InMemoryCache(), // Apollo Client Cache
});

// Ensure that the root element is not null before calling createRoot()
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
} else {
  console.error("Root element not found");
}

// Performance measuring (optional)
reportWebVitals();
